import { useMemo } from "react"
import { useAuthStore } from "@/src/store"
import { ROLES, type UserRole } from "@/src/features/internalUsers/constants"

export const useCurrentRole = () => {
    const user = useAuthStore((state) => state.user)
    const role = user?.activeWorkspace?.roleName || null

    return {
        role,
        isSuperAdmin: role === ROLES.SUPER_ADMIN,
        isInternal: role === ROLES.INTERNAL,
        isManager: role === ROLES.MANAGER,
        isRecruiter: role === ROLES.RECRUITER,
        hasRole: (targetRole: UserRole) => role === targetRole,
        hasAnyRole: (roles: UserRole[]) => (role ? roles.includes(role) : false),
    }
}
